/**
 * Entrega um arquivo gerado na tela para a pessoa salvar — F131.
 *
 * Pelo link com `download`, que é o caminho do navegador e também o do
 * aplicativo de desktop: o WebView2 do Windows trata o download como o Edge
 * (vai para a pasta Downloads). O endereço temporário é revogado depois de um
 * tempo, e não na hora — em alguns navegadores o download ainda não começou
 * quando o `click()` volta.
 */
export const saveFile = (
  name: string,
  type: string,
  content: string | Uint8Array<ArrayBuffer>
): void => {
  const url = URL.createObjectURL(new Blob([content], { type }))
  const link = document.createElement('a')
  link.href = url
  link.download = name
  link.style.display = 'none'
  document.body.append(link)
  link.click()
  link.remove()
  window.setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 60_000)
}
